import { Alert, AlertTitle } from '@repo/ui';
import cn from 'clsx';

import s from './Notice.module.scss';

import { useNotice } from '@/lib/hooks/api/query/use-notice';

const Notice = () => {
  const notice = useNotice();

  if (notice?.result && notice?.contents?.length && notice?.contents?.length > 0) {
    return (
      <div className={'pb-3 pt-2 notice-container page-padding'}>
        <div className={cn('bg-yellow-100 w-full mx-auto max-w-[520px] rounded-bzc-small', s.wrap)}>
          <Alert
            className={'flex items-center justify-center py-3 px-[18px]'}
            graphic={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/iconography/icg_exclamation-mark_sm.svg`} className={'w-6'} alt={''} />}
            variant="custom"
            size="small"
          >
            <AlertTitle className="grow break-all text-gray-800 body-13">{notice.contents}</AlertTitle>
          </Alert>
        </div>
      </div>
    );
  }

  return <></>;
};

export default Notice;
